export enum YesNo {
  YES = "YES",
  NO = "NO",
}
